import React from 'react';
import { useParams } from 'react-router-dom';

import SalesOrderDetailContainer from '@totem/components/salesOrders/details/SalesOrderDetailContainer';
import SalesOrderDetailLayout from '@totem/components/salesOrders/details/SalesOrderDetailLayout';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const SalesOrderDetailPage = () => {
  const { salesOrderNumber } = useParams<{ salesOrderNumber: string }>();

  return (
    <SalesOrderDetailContainer salesOrderNumber={salesOrderNumber}>
      <ContentLayout pageTitle={salesOrderNumber}>
        <SalesOrderDetailLayout salesOrderNumber={salesOrderNumber} />
      </ContentLayout>
    </SalesOrderDetailContainer>
  );
};

export default SalesOrderDetailPage;
